export function hasFreeShipping(user) {
  if (!user) {
    return true
  }

  return !!user.has_free_shipping_coupon || !!user.has_free_shipping_badge
}

export function isFirstOrder(user) {
  if (!user) {
    return true
  }

  return !user.has_purchased
}

export function intlUserHasFreeShippingCoupon(user, country) {
  return !!user && country !== 'US' && user.has_free_intl_shipping_coupon
}
